import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AiListingJobPage } from '@/components/AiListing/AiListingJobPage'
import { jobSearchSchema, withoutJobSearchDefaults } from '@/components/AiListing/search'

/**
 * Wiring only. `$jobId` matches the backend's `job_id`; the view state's
 * schema and pruning live beside the page in `search.ts`.
 */
export const Route = createFileRoute('/_app/ai-listing/$jobId')({
  validateSearch: jobSearchSchema,
  component: AiListingJobRoute,
})

function AiListingJobRoute() {
  const { jobId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <AiListingJobPage
      jobId={jobId}
      search={search}
      onSearchChange={(next) =>
        void navigate({
          search: (current) => withoutJobSearchDefaults({ ...current, ...next }),
          replace: true,
        })
      }
    />
  )
}
